import { AUTH_LOGIN, AUTH_LOGOUT, AUTH_ERROR, AUTH_CHECK, AUTH_GET_PERMISSIONS } from 'react-admin';
import { Api } from '../service/API';
import { HttpError } from 'ra-core';
import { PERMISSIONS } from '../consts/Names';

export const authProvider = (type, params) => {
    if (type === AUTH_LOGIN) {
        const { email, password } = params;

        return Api.Login(password, email).then((res) => {
            if (res.data.error || res.status !== 200) {
                Promise.reject(new HttpError(res.data.error, res?.status));
            } else {
                const { token, user_type } = res.data.success;
                if (user_type !== PERMISSIONS.ADMIN && user_type !== PERMISSIONS.CONTENT_MANAGER && user_type !== PERMISSIONS.CUSTOMER_SUPPORT_MANAGER)
                   return  Promise.reject(new HttpError('Forbidden ', "403"));
                localStorage.setItem('permissions', user_type);
                localStorage.setItem('token', token);
                return Promise.resolve();
            }
        });
    }

    if (type === AUTH_LOGOUT) {
        localStorage.removeItem('permissions');
        localStorage.removeItem('token');
        localStorage.clear();
        return Promise.resolve();
    }

    if (type === AUTH_ERROR) {
        if (params?.status === 401 || params?.status === 404) {
            localStorage.removeItem('permissions');
            localStorage.removeItem('token');
            localStorage.clear();
            return Promise.reject();
        }
        return Promise.resolve();
    }

    if (type === AUTH_CHECK) {
        return localStorage.getItem('token') ? Promise.resolve() : Promise.reject({ redirectTo: '/login' });
    }

    if (type === AUTH_GET_PERMISSIONS) {
        const role = localStorage.getItem('permissions');
        return role ? Promise.resolve(role) : Promise.reject();
    }
};